// Centralized anchor ids — referenced from both pages (data-tour-anchor)
// and tour scripts. Renaming is grep-safe.
export const TA = {
  ROUTINES_HEADER: 'routines-header',
  ROUTINES_CREATE_BTN: 'routines-create-btn',
  WIZARD_SHEET: 'wizard-sheet',
  WIZARD_SAVE_BTN: 'wizard-save-btn',
  WORKOUT_FIRST_SET_ROW: 'workout-first-set-row',
  WORKOUT_REST_TIMER: 'workout-rest-timer',
  WORKOUT_FINISH_BTN: 'workout-finish-btn',
  DIET_ADD_FOOD_BTN: 'diet-add-food-btn',
  DIET_PICKER_SEARCH: 'diet-picker-search',
  CHECKINS_NEW_BTN: 'checkins-new-btn',
  CHECKINS_INFO_AREA: 'checkins-info-area',
  NAV_WORKOUT: 'nav-workout-tab',
  NAV_DIET: 'nav-diet-tab',
  NAV_SOCIAL: 'nav-social-tab',
};
